import * as React from "react";
import type { SVGProps } from "react";
const SvgLogIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 2a1 1 0 1 0 0 2zm4 1V2zm-4 17a1 1 0 1 0 0 2zm-5.707-3.707a1 1 0 1 0 1.414 1.414zM15 12l.707.707a1 1 0 0 0 0-1.414zm-4.293-5.707a1 1 0 0 0-1.414 1.414zM3 11a1 1 0 1 0 0 2zm12-7h4V2h-4zm4 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 19 2zm.707.293A1 1 0 0 1 20 5h2a3 3 0 0 0-.879-2.121zM20 5v14h2V5zm0 14a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 22 19zm-.293.707A1 1 0 0 1 19 20v2a3 3 0 0 0 2.121-.879zM19 20h-4v2h4zm-8.293-2.293 5-5-1.414-1.414-5 5zm5-6.414-5-5-1.414 1.414 5 5zM15 11H3v2h12z"
    />
  </svg>
);
export default SvgLogIn;
